export default __webpack_public_path__ + "static/media/IMG_1428.c4cd6089.jpg";